(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('BlackoutPeriodDialogController', BlackoutPeriodDialogController);

    BlackoutPeriodDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BlackoutPeriod', 'User', 'Principal'];

    function BlackoutPeriodDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BlackoutPeriod, User, Principal) {
        var vm = this;

        vm.blackoutPeriod = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.isVcStaff = false;
        vm.appraisers = [];
        vm.selectedAppraiser = null;
        vm.matchAppraisers = matchAppraisers;
        vm.onAppraiserSelected = onAppraiserSelected;

        // VC staff (ADMIN, CCR, VC_*) pick which appraiser the blackout period belongs to via a
        // type-to-search field. Appraisers don't see the picker; the backend keeps their blackout
        // periods owned by themselves.
        Principal.matchAnyAuthority(/^ROLE_(ADMIN|CUSTOMER_CARE_REPRESENTATIVE|VC_.*)$/).then(function (isVcStaff) {
            vm.isVcStaff = isVcStaff;
            if (isVcStaff) {
                User.getAppraisersDropdown().$promise.then(function (appraisers) {
                    vm.appraisers = appraisers;
                    // When editing, pre-select the current owner so the search field shows their name.
                    if (vm.blackoutPeriod.userId) {
                        vm.selectedAppraiser = appraisers.filter(function (appraiser) {
                            return appraiser.id === vm.blackoutPeriod.userId;
                        })[0] || null;
                    }
                });
            }
        });

        // Filters the already-loaded appraiser list by first/last name as the user types.
        // Uses a case-insensitive substring match (not a shared global-flag regex, whose
        // stateful lastIndex would intermittently skip valid matches).
        function matchAppraisers (searchText, appraisers) {
            if (!searchText) {
                return appraisers;
            }
            var needle = searchText.toLowerCase();
            return appraisers.filter(function (appraiser) {
                return (appraiser.lastName + ', ' + appraiser.firstName)
                    .toLowerCase().indexOf(needle) !== -1;
            });
        }

        // Captures the selected appraiser's user id onto the model the backend expects.
        function onAppraiserSelected (appraiser) {
            vm.blackoutPeriod.userId = appraiser ? appraiser.id : null;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.blackoutPeriod.id !== null) {
                BlackoutPeriod.update(vm.blackoutPeriod, onSaveSuccess, onSaveError);
            } else {
                BlackoutPeriod.save(vm.blackoutPeriod, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:blackoutPeriodUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
